import { render, staticRenderFns } from "./DashboardPage.html?vue&type=template&id=0217c28f&scoped=true&external"
import script from "./DashboardPage.ts?vue&type=script&lang=ts&external"
export * from "./DashboardPage.ts?vue&type=script&lang=ts&external"
import style0 from "./DashboardPage.scss?vue&type=style&index=0&id=0217c28f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0217c28f",
  null
  
)

export default component.exports